<template>
  <SitecoreLink
    class="footer__column-link"
    :iconField="this.fields.LinkIcon"
    :linkField="this.fields.Link"
    :editable="false"
  ></SitecoreLink>
</template>

<script>
import SitecoreLink from '../../Sitecore/SitecoreLink';

export default {
  name: 'FooterColumnLink',
  components: {
    SitecoreLink,
  },
  data() {
    return {
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LinkIcon: null,
        Link: null,
      }),
    },
    params: {
      type: Object,
    },
  },
  computed: {
  },
};
</script>
<style lang="scss" scoped>
.footer__column-link:hover {
  text-decoration: underline;
}
.footer__column-link {
  &::v-deep {
    .experience-editor-link{
      a {
          text-decoration: none;
          color: #fff;
      }
      a:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>
